module.exports = __webpack_public_path__ + "static/media/codinative.5c6be314.jpg";